import React from "react";
import NextImage from "../NextImage";
import CurrencyIcon from "../icons/CurrencyIcon";
import useClient from "@/hooks/global/useClient";
import { fastDeliveryDisplayTypes } from "@/constants/FastDelivery";
import { sanitizeHtml } from "@/utils/sanitizeHtml";
export default function DeliveryInfoCard({
  locale,
  srcIcon,
  title,
  items,
  type,
}) {
  const { isClient } = useClient();

  const renderContentByType = () => {
    switch (type) {
      case fastDeliveryDisplayTypes.KEY_VALUE:
        return (
          <ul className="space-y-2 font-[500] lg:w-74">
            {isClient &&
              items?.map((item, index) => {
                const text = locale === "en" ? item?.text : item?.text_ar;
                const [key, value] = text?.split(":");
                const parts = value?.split("SAR");
                return (
                  <li
                    key={index}
                    className="flex items-start text-[16px] max-sm:text-sm"
                  >
                    <span className="mr-2 rtl:mr-0 rtl:ml-2">•</span>
                    <div className="inline">
                      <div className="flex">
                        <div className="min-w-[100px] shrink-0 pe-1">
                          {key && <span className="text-nowrap">{`${key}:`}</span>}
                        </div>
                        <div className="">
                          {parts?.map((part, idx) => (
                            <React.Fragment key={idx}>
                              <span
                                dangerouslySetInnerHTML={{ __html: sanitizeHtml(part) }}
                              />
                              {idx < parts.length - 1 && (
                                <CurrencyIcon className="w-auto inline-block h-[1.3cap]" />
                              )}
                            </React.Fragment>
                          ))}
                        </div>
                      </div>
                    </div>
                  </li>
                );
              })}
          </ul>
        );
      case fastDeliveryDisplayTypes.TEXT:
        return (
          <ul className="space-y-2 font-[500] lg:w-74">
            {isClient &&
              items?.map((item, index) => {
                const text = locale === "en" ? item?.text : item?.text_ar;
                const parts = text?.split("SAR");
                return (
                  <li
                    key={index}
                    className="flex items-start text-[16px] max-sm:text-sm"
                  >
                    <span className="mr-2 rtl:mr-0 rtl:ml-2">•</span>
                    <div className="inline">
                      {parts?.map((part, idx) => (
                        <React.Fragment key={idx}>
                          <span dangerouslySetInnerHTML={{ __html: sanitizeHtml(part) }} />
                          {idx < parts.length - 1 && (
                            <CurrencyIcon className="w-auto inline-block h-[1.3cap]" />
                          )}
                        </React.Fragment>
                      ))}
                    </div>
                  </li>
                );
              })}
          </ul>
        );
      default:
        return null;
    }
  };

  return (
    <div className="space-y-4">
      <div className="flex items-start gap-4">
        <div className="p-1 flex-shrink-0 h-[30px] w-[30px] rounded">
          <NextImage
            src={srcIcon}
            className="w-full h-full"
            alt="title"
            width={150}
            height={150}
          />
        </div>
        <div className="text-blue flex flex-col md:flex-row gap-1 md:gap-5">
          <h2 className="text-lg font-[400] mb-2 text-[#909090] lg:w-40">
            {`${title}:`}
          </h2>
          {renderContentByType()}
        </div>
      </div>
    </div>
  );
}
